import { createSlice } from "@reduxjs/toolkit";
import { getListChangePointCustomer } from "../../api/ChangePoint/changePointCustomer";

// giá trị khởi tạo của state
const initialState = {
  listChangePointCustomer: [],
  isLoadChangePointCustomer: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0,
};

const changePointCustomerSlice = createSlice({
  name: "changePointCustomer",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListChangePointCustomer.pending, (state) => {
        state.isLoadChangePointCustomer = true;
        state.error = null;
      })
      .addCase(getListChangePointCustomer.fulfilled, (state, action) => {
        state.isLoadChangePointCustomer = false;
        state.listChangePointCustomer = action.payload.data || [];
        state.currentPage = action.payload.current_page;
        state.pageSize = action.payload.per_page;
        state.totalRecords = action.payload.total;
      })
      .addCase(getListChangePointCustomer.rejected, (state, action) => {
        state.isLoadChangePointCustomer = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  changePointCustomerSlice.actions;
export default changePointCustomerSlice.reducer;
